import { DataSnapshotPages } from "@constants";
import { asRoundedPercentage } from "@components/Filters/number.js";
import pbiTile from "@public-client/Components/Charts/PBI.Tile.vue";
import ExpandingDataCard from "@public-client/Components/ExpandingDataCard.vue";
import StateReportHighlights from "./StateReport.Highlights.vue";
export default {
  components: {
    pbiTile,
    ExpandingDataCard,
    StateReportHighlights
  },
  filters: {
    asRoundedPercentage
  },
  data() {
    return {
      snapShot1_page: DataSnapshotPages.stateWide.Gender,
      snapshotPages: DataSnapshotPages.stateWide
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading || !this.programs.length;
    },
    cycle() {
      let target = this.$store.getters.cycle;
      return target ? target : {};
    },
    programs() {
      return this.$store.state.programs;
    },
    stateSummary() {
      return this.$store.getters.stateSummary;
    },
    snapShot1_filters() {
      let cycleYear = this.cycle.IPPCycleYear;
      if (cycleYear == null) cycleYear = 2022;
      return [{
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Race/Ethnicity Snapshot",
          column: "IPPCycleYear"
        },
        operator: "Is",
        values: [cycleYear],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Gender Snapshot",
          column: "IPPCycleYear"
        },
        operator: "Is",
        values: [cycleYear],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Demographic Snapshot",
          column: "IPPCycleYear"
        },
        operator: "Is",
        values: [cycleYear],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }];
    },
    snapShot2_filters() {
      let cycleYear = this.cycle.IPPCycleYear;
      if (cycleYear == null) cycleYear = 2022;
      return [{
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Trending Enrollment Snapshot",
          column: "IPPCycleYear"
        },
        operator: "Is",
        values: [cycleYear],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }];
    }
  }
};